import Script from "next/script";

export const PrefetchAppRoutes = () => {
  const speculationRules = {
    // prerenders in another tab and switches on navigation, Only sign-up is needed for now. sign-in shoul already be cached by most users since they have already been to the site before.
    prerender: [
      {
        source: "document",
        eagerness: "eager",
        where: { href_matches: "/app/sign-up*" },
      },
    ],
    // prefetch /app links
    prefetch: [
      {
        where: { href_matches: "/app/*" },
        eagerness: "eager",
      },
    ],
  };

  // We could also add these but couldn't find a way to do it. Looks like nextjs doesn't actually support it
  /*
        <link as='document' href='/app/sign-up' rel='prefetch' />
        <link as='document' href='/app/sign-in' rel='prefetch' />
        <link as='document' href='/app/home' rel='prefetch' />
  */
  return (
    <>
      <Script
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(speculationRules),
        }}
        id='prefetch-app-routes'
        strategy='beforeInteractive' // forces it to load in the head...
        type='speculationrules'
      />
    </>
  );
};
